<div class="ml-auto font-bold underline text-qr_color-blue_1 hover:cursor-pointer">
  {{$t('qr_reset_address.reset_address')}}
</div>